import React, { CSSProperties, useCallback } from "react";
import classNames from "classnames";
import {
   DropdownItem,
   DropdownMenu,
   DropdownToggle,
   UncontrolledDropdown,
} from "Components/ReactstrapSlim";
import { ArrowLeftAlt, Calculator } from "Components/Icons";
import { getScrollbarWidth } from "Utils/getScrollbarWidth";
import { CATEGORIES, MODIFIERS } from "./constants";
import CategoryList from "./CategoryList";
import SolutionCard from "./SolutionCard";

import dropdownClasses from "./ClearDropdown.module.scss";
import classes from "./SolutionsDropdown.module.scss";

const menuStyle = {
   "--scrollbar-width": getScrollbarWidth() + "px",
} as CSSProperties;

const SolutionsDropdown: React.FC = () => {

   const action = useCallback(() => {
      window.open("/portfolio-manager-ai");
   }, []);

   return (
      <UncontrolledDropdown>
         <DropdownToggle caret color="transparent" className="header-btn-link">
            Solutions
         </DropdownToggle>
         <DropdownMenu
            modifiers={MODIFIERS}
            className={classes.dropdownMenu}
            style={menuStyle}
            cssModule={dropdownClasses}
         >
            <div className={classes.dropdownMenuContainer}>
               <div
                  className={classNames(
                     classes.dropdownMenuContent,
                     classes.dropdownContentContainer,

                  )}
               >
                  {CATEGORIES.map((category, i) => (
                     <div key={i} className={classes.dropdownMenuItems}>
                        {category.map(({ title, items }) => (
                           <CategoryList
                              key={title}
                              title={title}
                              items={items}
                           />
                        ))}
                     </div>
                  ))}
                  {LiquidSpaceConfig.ShowPortfolioManagerNavigationLinks && <SolutionCard
                     className={classes.card}
                     icon={<Calculator size={32} />}
                     title="Run the Numbers"
                     description="Model the ROI of your workplace strategy."
                     actionText="Analyze your ROI"
                     action={action}
                  />}
               </div>
            </div>
            <div className={classes.dropdownMenuBanner}>
               <div className={classes.dropdownContentContainer}>
                  <DropdownItem
                     cssModule={dropdownClasses}
                     className={classes.dropdownMenuBannerLink}
                     href="/share-office-meeting-space"
                  >
                     <span className={classes.dropdownMenuBannerText}>
                        Coworking hosts, click here to list your workspace.
                     </span>
                     <ArrowLeftAlt className={classes.dropdownMenuBannerIcon} />
                  </DropdownItem>
               </div>
            </div>
         </DropdownMenu>
      </UncontrolledDropdown>
   );
};

export default SolutionsDropdown;
